import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User } from "oidc-client-ts";

interface AuthProviderState {
  user: User | null;
  isLoading: boolean;
}

const initialState: AuthProviderState = {
  user: null,
  isLoading: true,
};

export const authProviderSlice = createSlice({
  name: "authProvider",
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<User | null>) => {
      state.user = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
  },
});

export const { setUser, setLoading } = authProviderSlice.actions;

export default authProviderSlice.reducer;
